export const countryAndRegions = {
    France: [
      'Auvergne-Rhône-Alpes',
      'Bourgogne-Franche-Comté',
      'Bretagne',
      'Centre-Val de Loire',
      'Corse',
      'Grand Est',
      'Hauts-de-France',
      'Île-de-France',
      'Normandie',
      'Nouvelle-Aquitaine',
      'Occitanie',
      'Pays de la Loire',
      "Provence-Alpes-Côte d'Azur",
      'Guadeloupe',
      'Guyane',
      'Martinique',
      'La Réunion',
      'Mayotte',
    ],
    'Pays-Bas': [],
    Japon: [],
    Bulgarie: [],
    Finlande: [],
    Philippines: [],
    Roumanie: [],
    Serbie: [],
    Singapour: [],
    Suède: [],
    Ukraine: [],
    'Etats-Unis': [],
    'Royaume-Uni': [],
    Allemagne: [],
    Chine: [],
    Canada: [],
    Australie: [],
    'Autre (Europe)': [],
    'Autre (Monde)': [],
  };

  export const companyData = {
    "3Ddd Games Sas": "Studio",
    "7-Shapes": "Studio",
    "A Better Prod": "Non JV",
    "Activdesign": "Studio",
    "Adeliom": "Non JV",
    "ADEME": "Non JV",
    "Aelan": "Non JV",
    "Aeterna Fabula Studio": "Studio",
    "Afterclimate": "Autre",
    "Agence 3X+": "Non JV",
    "Aktio": "Non JV",
    "Alambik Studio": "Studio",
    "Alkemi": "Studio",
    "All In One Production": "Studio",
    "Almédia": "Studio",
    "Alt Shift": "Studio",
    "Altair": "Autre",
    "Amplitude Studios": "Studio",
    "Andeludus": "Studio",
    "Ang+": "Studio",
    "Ankama": "Studio",
    "APL Datacenter": "Autre",
    "Apologue FX": "Autre",
    "Apperture": "Studio",
    "Arcep": "Non JV",
    "Archipel": "Studio",
    "Architects Republic": "Studio",
    "Arkane": "Studio",
    "Art Factory Formation": "Autre",
    "ARTE France": "Editeur",
    "Artefacto": "Autre",
    "Artefacts Studio": "Studio",
    "Artisan Studios": "Studio",
    "Artiste-Auteur Urssaf": "Non JV",
    "ARVIVA": "Non JV",
    "Asobo Studio": "Studio",
    "Asociacion Huella De Carbono": "Non JV",
    "Association Nintend'Oz-Event": "Asso JV",
    "Association Pour La Transition Bas Carbone": "Non JV",
    "Astral Forge": "Studio",
    "Atelier Daruma": "Studio",
    "Atelier QDB": "Studio",
    "Atlangames": "Asso JV",
    "Atlas V": "Studio",
    "Attaboy Interactive": "Studio",
    "Avalanche Studios": "Studio",
    "Awarecorp Studios": "Studio",
    "Awesome Alpaca'S Atelier": "Studio",
    "Awesome Game Concepts": "Studio",
    "Axel Conseil": "Non JV",
    "Ayming": "Non JV",
    "AZER-T": "Studio",
    "Backlight Studio": "Studio",
    "Bad Marines Studio": "Studio",
    "Baker Tilly": "Autre",
    "Banana Blitz": "Studio",
    "Beemoov": "Studio",
    "Beija Flor": "Studio",
    "BEMS (Gravenoire Studio)": "Autre",
    "Biborg": "Studio",
    "Big Bad Wolf": "Studio",
    "Big Time Labs": "Studio",
    "Bigwhoop": "Autre",
    "Binogure Studio": "Studio",
    "Biscuitfactory": "Studio",
    "Bittersweet Systems": "Non JV",
    "BL Evolution": "Non JV",
    "BLAM": "Non JV",
    "Bleu Matin": "Non JV",
    "Blight Entertainment": "Studio",
    "Blind Bend Studio": "Studio",
    "BoCAJ": "Asso JV",
    "Boissel.Dev": "Non JV",
    "BONOBROS GAMES": "Studio",
    "Brains & Games": "Autre",
    "Brassart": "Ecole",
    "Breakfirst Games": "Studio",
    "Bretagne Compétitivité": "Non JV",
    "Ça Part En Prod": "Studio",
    "Caisse Des Depôts": "Non JV",
    "Caldera Interactive": "Studio",
    "Capgame": "Asso JV",
    "Capgemini TS": "Non JV",
    "Capital Games": "Asso JV",
    "Carbone Culture": "Non JV",
    "Carpool Studio": "Studio",
    "Cassiopeia Developments": "Studio",
    "Casus Ludi": "Studio",
    "Catontree Studio": "Studio",
    "Catsandfoxes": "Studio",
    "Celsius Online": "Studio",
    "Cenote": "Studio",
    "Centre Des Possibles": "Non JV",
    "Centurion Developments": "Studio",
    "Chaotic Games": "Studio",
    "Chaotic Krafterz": "Studio",
    "Charlathan Club": "Studio",
    "Chewing Games": "Studio",
    "Chonky Frog Studio": "Studio",
    "Choose Red": "Studio",
    "CITIA": "Autre",
    "Clarté": "Non JV",
    "CNAM": "Ecole",
    "CNC": "Autre",
    "Coblence ": "Non JV",
    "Code Chlorophylle": "Non JV",
    "Collectif Bouftang": "Asso JV",
    "CoMuter": "Non JV",
    "CONATEL": "Non JV",
    "Converteo": "Non JV",
    "Coopérative Carbone": "Non JV",
    "Court-Jus Production": "Autre",
    "Coven": "Studio",
    "C-Paje": "Asso JV",
    "Crédit Agricole Charente-Périgord": "Non JV",
    "Ctrl S Studio": "Non JV",
    "Cyanide": "Studio",
    "Damnatio Games": "Studio",
    "Dantronix Corporation Ltd.": "Non JV",
    "Darjeeling": "Studio",
    "Dataspelsbranschen": "Asso JV",
    "Deneos": "Studio",
    "Dev-Id": "Studio",
    "Dev-Id Marseille": "Non JV",
    "Digixart Entertainment": "Studio",
    "DIPLOIDE": "Non JV",
    "Disruptive Dynamics": "Autre",
    "Dithernet": "Autre",
    "DNE": "Non JV",
    "Dodorassik Games": "Studio",
    "Dods": "Studio",
    "DONTNOD Entertainment": "Studio",
    "Doryah Games": "Studio",
    "Dotemu": "Editeur",
    "Double Jack": "Studio",
    "Douze Dixièmes": "Studio",
    "DOWiNO": "Studio",
    "Drama Studios": "Studio",
    "Draw Me A Pixel": "Studio",
    "Dream Makers Circus": "Studio",
    "Dreets Ara": "Non JV",
    "Drop Rate Studio": "Studio",
    "Duckstorm Games": "Studio",
    "Dunlin Productions": "Non JV",
    "East Games": "Asso JV",
    "ECO2 Initiative": "Non JV",
    "EcoAct": "Non JV",
    "EcoMicro": "Non JV",
    "Ecoprod": "Non JV",
    "Ecoptimum Conseil": "Non JV",
    "Eco-Stratégie": "Non JV",
    "Eden Games": "Studio",
    "Effets De Ser": "Non JV",
    "Eiffage": "Non JV",
    "Eirl ExServ": "Autre",
    "Electronic Arts": "Editeur",
    "Elseware experience": "Studio",
    "Elyth Games": "Studio",
    "Empreintes Studio": "Studio",
    "Endroad": "Studio",
    "ENJMIN": "Ecole",
    "EODE": "Studio",
    "Equasens": "Non JV",
    "Eriomem": "Autre",
    "Ernestine": "Studio",
    "Escale Creative": "Autre",
    "Esie Paris": "Ecole",
    "ESMA": "Ecole",
    "Eternilab": "Non JV",
    "Eugen Systems": "Studio",
    "EV.L prod": "Studio",
    "Event Orizon": "Studio",
    "Evil Empire": "Studio",
    "Evil Raptor": "Studio",
    "Exalted Studio": "Studio",
    "eXcent": "Non JV",
    "Expansi": "Non JV",
    "Fabloo Games": "Editeur",
    "Faefolks": "Studio",
    "Fairly": "Non JV",
    "Federation Studios": "Studio",
    "Fiona Mantovi Ei": "Non JV",
    "First Pick Studios": "Studio",
    "Flanders Audiovisual Fund": "Autre",
    "Flying Secoya": "Non JV",
    "Freya Games": "Studio",
    "From The French": "Studio",
    "Frozax Games": "Studio",
    "Fueled": "Studio",
    "G4F Prod": "Studio",
    "Gallisenae": "Studio",
    "Gamabilis": "Studio",
    "Game Habitat": "Asso JV",
    "Game In": "Asso JV",
    "Game In Society": "Studio",
    "Game Only": "Asso JV",
    "GAME SOURCE STUDIO": "Studio",
    "Gamecostudios": "Studio",
    "GAMELEON": "Studio",
    "Gamesplanet.com": "Autre",
    "Gamevrest": "Studio",
    "Gamific": "Studio",
    "Gaming Campus": "Ecole",
    "Gamlox Studio": "Studio",
    "Givegamestudio": "Studio",
    "GMX": "Non JV",
    "Gobelins": "Ecole",
    "Goblinz Studio": "Editeur",
    "Goodwill-Management": "Non JV",
    "Grafitoid": "Studio",
    "Graou Studio": "Studio",
    "Greenflex": "Non JV",
    "Greenspector": "Non JV",
    "Grinta Games": "Studio",
    "Haan, Janssen And Klein": "Non JV",
    "Hallucinations Studio": "Studio",
    "Harmonie Games": "Studio",
    "Hawkswell": "Studio",
    "Hectiq": "Studio",
    "Helpy SAS": "Studio",
    "Hibernian Workshop": "Studio",
    "Hiver Prod": "Studio",
    "Hocusbookus": "Non JV",
    "Hom": "Non JV",
    "Homo Ludens": "Studio",
    "Hub.Brussels": "Non JV",
    "Humble Reeds": "Studio",
    "I Care": "Non JV",
    "ICO": "Autre",
    "IET": "Non JV",
    "IIM Digital School": "Ecole",
    "Ikimasho": "Studio",
    "IKO": "Studio",
    "Impacterz Studio": "Studio",
    "INA Sup": "Ecole",
    "INRIA": "Non JV",
    "Invanotion": "Non JV",
    "Ironequal": "Studio",
    "ISART Digital": "Ecole",
    "Ishtar Games": "Studio",
    "IUT Angouleme": "Ecole",
    "Ivory Tower": "Studio",
    "Jazz Développement": "Non JV",
    "Jobtaste": "Studio",
    "Juvenile Pursuits Inc.": "Studio",
    "Kalank": "Studio",
    "Kernix": "Non JV",
    "Keyrus": "Autre",
    "Kimeria Games": "Studio",
    "KO_OP": "Studio",
    "Komet Xperience": "Studio",
    "Kprod": "Non JV",
    "Ku Leuven": "Non JV",
    "Kylii Kids": "Autre",
    "Kylotonn": "Studio",
    "La 37Ème Chambre": "Non JV",
    "La Belle Games": "Studio",
    "La Joliverie": "Ecole",
    "La Poule Noire": "Studio",
    "L'Atelier": "Studio",
    "Lazag Studio": "Studio",
    "LCA Solutions+": "Non JV",
    "LDLC VR Studio": "Studio",
    "Le Studio De Trop": "Studio",
    "L'École De Design Nantes Atlantique": "Ecole",
    "Legou Games Paris SAS": "Studio",
    "Leikir Studio": "Studio",
    "Les Crafteurs": "Studio",
    "Light & Shadows": "Studio",
    "Littlefield Studio": "Studio",
    "Ludogram": "Studio",
    "LUDyLAB": "Studio",
    "Lugludum": "Studio",
    "Mad Mango Games": "Studio",
    "Mainbot": "Studio",
    "Makea Games": "Studio",
    "Maluska ": "Studio",
    "Mansion Games": "Studio",
    "Manufacture 43": "Studio",
    "Marilie&Co'": "Autre",
    "Mavana": "Non JV",
    "Medulla": "Studio",
    "Mi-Clos": "Studio",
    "Microids": "Editeur",
    "Midgard": "Autre",
    "Million Victories": "Studio",
    "Ministère De La Culture": "Non JV",
    "Mode Miroir": "Autre",
    "Moonweaver Games": "Studio",
    "Morbleu!": "Studio",
    "MTECT": "Non JV",
    "Multiple (Consultant Indépendant)": "Non JV",
    "Muruastudio": "Studio",
    "MyLOOT": "Autre",
    "N130": "Studio",
    "NABIYA": "Studio",
    "NEO-FUGU": "Non JV",
    "Neogames Finland Ry": "Asso JV",
    "New Tales": "Studio",
    "News Tank": "Non JV",
    "Nice Penguins": "Studio",
    "Noisette Studio": "Studio",
    "Nova-Box": "Studio",
    "Nustrale Studios": "Studio",
    "N-Zone": "Studio",
    "O2M Développement Durable": "Non JV",
    "Ocellus Studio": "Studio",
    "Octopoulpe Studio": "Studio",
    "Oh BiBi": "Studio",
    "Old Skull Games": "Studio",
    "One Family Army": "Autre",
    "Oneiric Worlds": "Studio",
    "Openstudio": "Autre",
    "Operating Dwarves": "Studio",
    "OPIA GAMES": "Studio",
    "Optizonion": "Studio",
    "Orange": "Autre",
    "Orbi Universo Team Sarl": "Studio",
    "Osome Studio": "Studio",
    "Ottertech": "Studio",
    "Ouebsson": "Studio",
    "Out Of Time": "Studio",
    "Pamcha": "Studio",
    "Papasta": "Non JV",
    "Parallel Minds": "Studio",
    "Paris Musées": "Non JV",
    "Passtech Games": "Studio",
    "Pastagames": "Studio",
    "PCS Avocat": "Non JV",
    "Persistant Studios": "Studio",
    "Phoenix Block3": "Autre",
    "Piece Of Cake Studios": "Studio",
    "Pilo Team (Mudita Games)": "Studio",
    "Pixel Players": "Asso JV",
    "Pixel Sunset Studio": "Studio",
    "Pixel Wrappers": "Studio",
    "Plaine Images": "Non JV",
    "Play Curious": "Studio",
    "Playbase Agency": "Autre",
    "Playdigious": "Editeur",
    "Playdoll": "Studio",
    "Playing 4 The Planet": "Asso JV",
    "Playruo (Eshot Labs)": "Autre",
    "Pleistogames": "Autre",
    "Plip !": "Studio",
    "Plutot.Cool": "Non JV",
    "Polycorne": "Studio",
    "Porcupine Parkour": "Studio",
    "Purrfect": "Non JV",
    "Push Start": "Asso JV",
    "Quantic Dream Sas": "Studio",
    "R3": "Non JV",
    "Ramage Games": "Studio",
    "Ratel Studio": "Studio",
    "Reaali": "Studio",
    "Reallyreallyreal": "Studio",
    "Rebel Pixel": "Studio",
    "Rebound Capital Games": "Studio",
    "Recall Interactive": "Studio",
    "Réciproque": "Non JV",
    "Recursiveness": "Non JV",
    "Redlock Studio": "Studio",
    "Redwig.Studio": "Studio",
    "Reflita": "Non JV",
    "Région Nouvelle-Aquitaine": "Non JV",
    "Rekka Games": "Studio",
    "Relate Games": "Studio",
    "Rerolled": "Studio",
    "Resilio": "Non JV",
    "Resonance Interactive": "Studio",
    "Rivrs": "Studio",
    "Rockin' Games": "Studio",
    "Roost Games": "Studio",
    "Rsm France": "Non JV",
    "Rubika": "Ecole",
    "Runes Studio": "Studio",
    "Rxlaboratory": "Non JV",
    "Saltitude": "Studio",
    "Sami": "Non JV",
    "Sandfall Interative": "Studio",
    "Saraband": "Autre",
    "SAS Sunny Peak": "Studio",
    "Savage Level": "Studio",
    "Scifungames": "Studio",
    "Seaven Studio": "Autre",
    "Sébastien Guérin": "Non JV",
    "Seed By Seed": "Studio",
    "Sentiers Obliques": "Non JV",
    "Shiro Games": "Studio",
    "Siderift": "Studio",
    "Simplon": "Ecole",
    "Simplycarbon": "Non JV",
    "Sirène Rouge Games": "Studio",
    "Skoll Et Hati Studio": "Studio",
    "Slayo Games": "Autre",
    "Slim Cricket": "Studio",
    "Sloclap": "Studio",
    "Slovak Film Commission": "Non JV",
    "Smart Tale Games": "Studio",
    "SNJV": "Asso JV",
    "SO Games": "Asso JV",
    "Soywar": "Studio",
    "SPI (Synidcat des Producteurs Indépendants)": "Non JV",
    "Spiders": "Studio",
    "Spielfabrique": "Autre",
    "Splashteam": "Studio",
    "Spooky Rabbits": "Studio",
    "Spore and Sorcery": "Studio",
    "Starlight Games": "Studio",
    "Stellar Games": "Studio",
    "Stormancer": "Autre",
    "Studio Berenice": "Studio",
    "Studio Camelia": "Studio",
    "Studio Eclipse": "Studio",
    "Studio Nyx": "Studio",
    "Studio RDZ": "Studio",
    "Studio Spektar": "Studio",
    "Sunny Lab": "Studio",
    "Supbiotech": "Non JV",
    "Swwwap": "Studio",
    "Symmetry Break Studio": "Studio",
    "Synnaxium Studio": "Studio",
    "Sytroningame(S)": "Studio",
    "Tactical Adventures": "Studio",
    "Tant Mieux Prod": "Autre",
    "Tavroxgames": "Studio",
    "Team Panoptes": "Studio",
    "Team Pebbles": "Studio",
    "TeamTO": "Non JV",
    "TechB": "Autre",
    "Télécom SudParis": "Ecole",
    "Temesis": "Non JV",
    "Terra 21": "Non JV",
    "The Carbon Trust": "Non JV",
    "The Game Atelier": "Studio",
    "The Game Bakers": "Studio",
    "The Pawn": "Autre",
    "The Shift Project": "Non JV",
    "The Tiny Digital Factory": "Studio",
    "TheGreenDhot": "Non JV",
    "TheRed Games": "Studio",
    "Tin Can Studio": "Studio",
    "Tinyforest": "Studio",
    "Tohu Bohu Games": "Studio",
    "Tokiko Studio": "Studio",
    "TOMAGameStudio": "Studio",
    "Truemotion": "Non JV",
    "U&We": "Non JV",
    "Ubisoft": "Editeur",
    "Ukiyo Studio": "Studio",
    "Umeshu Lovers": "Studio",
    "Umweltify": "Non JV",
    "Unexpected": "Studio",
    "Unifrance": "Autre",
    "Universcience": "Non JV",
    "Université De Lausanne": "Ecole",
    "Université De Poitiers": "Ecole",
    "Université Paul-Valéry Montpellier": "Ecole",
    "Université Poitiers": "Ecole",
    "Unlimited Spoons": "Studio",
    "UQAC": "Ecole",
    "Urbanomy": "Non JV",
    "USPA": "Non JV",
    "VanilleDeluxe SAS": "Studio",
    "Very Up": "Non JV",
    "V-Event": "Autre",
    "Video Games Europe": "Autre",
    "Vinland Games": "Studio",
    "VINNO": "Studio",
    "Virtualyz": "Studio",
    "Vision Denmark": "Autre",
    "Vision Reelle": "Studio",
    "Vivendi": "Non JV",
    "VRAI Studio": "Studio",
    "Wanadev": "Studio",
    "WeCount": "Non JV",
    "What The Prod": "Studio",
    "Wild Wits Games": "Studio",
    "Wogstudio": "Studio",
    "Women In Games": "Asso JV",
    "Wondersoft Studio": "Studio",
    "WTVR games": "Studio",
    "Xilam": "Autre",
    "XP School": "Ecole",
    "XXXArcadeGames": "Studio",
    "Ynov Lyon": "Ecole",
    "Ynov Nantes": "Ecole",
    "Yorf Studio": "Studio",
};
